import { AuthenticationException } from './authentication-exception';

export class AccountDisabledException extends AuthenticationException { }
